import api from './utilPartner';

const controller = 'PessoaRelacionamentoEmpresa';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  LocalizarRegistroPorParceiro: function (dto) {
    return api.Axios.GetParams(url + '/LocalizarRegistroPorParceiro', dto);
  }
});
